import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5dfe8a85"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5dfe8a85&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/opter/repo/code/cloudsee-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dfe8a85')) {
      api.createRecord('5dfe8a85', component.options)
    } else {
      api.reload('5dfe8a85', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5dfe8a85", function () {
      api.rerender('5dfe8a85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DictSelect/index.vue"
export default component.exports